import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import LocationStudentTableComp from "./Component/LocationStudentTableComp"


const LocationStudentTable =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <LocationStudentTableComp />
        </div>
        <Footer />
        </>
    )
}

export default LocationStudentTable